// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .notification-popup {
    position: absolute;
    top: 70px;
    right: 50px;
    width: 300px;
    padding: 20px;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    color: black;
  } */
  /* .notification-popup {
    position: absolute; 
    top: 70px; 
    right: 20px; 
    width: 300px;
    padding: 15px;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    color: black;
  }
 
  
  .notification-popup h3 {
    margin: 0;
    margin-bottom: 10px;
  }
  
  .notification-popup p {
    margin: 0;
  }

  .no-notifications {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  
  .no-notifications img {
    margin-bottom: 10px;
  }
   */


   /* ///////////////////////////////// */

   .notification-popup {
    position: absolute !important;
    top: 70px;
    right: 30px;
    /* width: 550px; */
    width: 550px;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #dcdcdc;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    color: #333; 
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.notification-popup h3 {
    margin: 0 0 15px;
    font-size: 18px;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

.notification-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.notification-card {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.notification-card:hover {
    background-color: #f0f0f0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.notification-icon {
    font-size: 17px;
    color: #4f6ee8;
    margin-right: 15px;
    flex-shrink: 0;
    align-self: flex-start;
    width: 20px;
    
}

/* .notificationtraining-icon{
    font-size: 15px;
    color: #007bff;
    margin-right: 15px;
    flex-shrink: 0;
    align-self: flex-start;
} */
/* .notification-icon {
    margin-right: 10px;
    font-size: 1.5rem;
    color: #75c5f4;
  } */
  
  .notification-icon.faChalkboardTeacher {
    color: #4a90e2 !important;
  }
  
  .notification-icon.faBook {
    color: #e94e77 !important;
  }
.notification-content {
    flex-grow: 1;
    display: flex;
    align-items: left; /* Aligns text vertically centered with the icon */
    /* justify-content: space-between; */
    text-align: left;
    margin-left: 5px !important;
    justify-content: space-between;
    cursor: pointer;
    
    
}

.notification-content p {
    margin: 0;
    font-size: 15px;
    color: #555;
    text-align: left !important;
    white-space: normal;
    word-wrap: break-word;
    
}

.notification-title {
    margin: 0;
    font-size: 18px;
    color: #444;
    font-weight: 600;
  }

.click-to-view {
    color: #888;
    font-size: 13px !important;
    margin-top: 8px !important;
    text-align: right !important;
    flex-shrink: 0 !important; /* Prevents the text from shrinking */
    margin-left: 0 !important; /* Adds space between the title and "click to view" */
    white-space: nowrap;
    margin-left: auto !important;
    
}

.no-notifications {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.no-notifications img {
    margin-bottom: 10px;
    width: 100px;
    height: 100px;
    opacity: 0.7;
}

.no-notifications p {
    color: #777;
    font-size: 16px;
    font-weight: 500;
}
.notification-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    max-height: 300px; /* Adjust based on your needs */
    overflow-y: auto; /* Enables vertical scrolling */
  }
  .notification-list::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }
  
  .notification-list::-webkit-scrollbar-track {
    background: #f9f9f9; /* Light background for the track */
  }
  
  .notification-list::-webkit-scrollbar-thumb {
    background: #ccc; /* Light gray thumb */
    border-radius: 10px; /* Rounded thumb */
    border: 2px solid #f9f9f9; /* Slight border around the thumb */
  }
  
  .notification-list::-webkit-scrollbar-thumb:hover {
    background: #aaa; /* Darker gray on hover */
  }
  
  /* Custom scrollbar for Firefox */
  .notification-list {
    scrollbar-width: thin; /* Thin scrollbar width */
    scrollbar-color: #ccc #f9f9f9; /* Thumb color and track color */
  }

  .notification-header {
    display: flex;
    justify-content: space-between;
    
    margin-bottom: 15px;
  }

  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
    color: #888;
  }
  .clear-all-button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 10px !important;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Notification/Notification.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;KAWK;EACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAkCE;;;GAGD,sCAAsC;;GAEtC;IACC,6BAA6B;IAC7B,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,WAAW;IACX,4DAA4D;AAChE;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,WAAW;;AAEf;;AAEA;;;;;;GAMG;AACH;;;;KAIK;;EAEH;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB,EAAE,kDAAkD;IACrE,oCAAoC;IACpC,gBAAgB;IAChB,2BAA2B;IAC3B,8BAA8B;IAC9B,eAAe;;;AAGnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;;AAEzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;AAEF;IACI,WAAW;IACX,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB,EAAE,qCAAqC;IAChE,yBAAyB,EAAE,qDAAqD;IAChF,mBAAmB;IACnB,4BAA4B;;AAEhC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,iBAAiB,EAAE,+BAA+B;IAClD,gBAAgB,EAAE,+BAA+B;EACnD;EACA;IACE,UAAU,EAAE,2BAA2B;EACzC;;EAEA;IACE,mBAAmB,EAAE,mCAAmC;EAC1D;;EAEA;IACE,gBAAgB,EAAE,qBAAqB;IACvC,mBAAmB,EAAE,kBAAkB;IACvC,yBAAyB,EAAE,mCAAmC;EAChE;;EAEA;IACE,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA,iCAAiC;EACjC;IACE,qBAAqB,EAAE,yBAAyB;IAChD,6BAA6B,EAAE,gCAAgC;EACjE;;EAEA;IACE,aAAa;IACb,8BAA8B;;IAE9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B","sourcesContent":["/* .notification-popup {\r\n    position: absolute;\r\n    top: 70px;\r\n    right: 50px;\r\n    width: 300px;\r\n    padding: 20px;\r\n    background-color: white;\r\n    border: 1px solid #ccc;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    z-index: 1000;\r\n    color: black;\r\n  } */\r\n  /* .notification-popup {\r\n    position: absolute; \r\n    top: 70px; \r\n    right: 20px; \r\n    width: 300px;\r\n    padding: 15px;\r\n    background-color: white;\r\n    border: 1px solid #ccc;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    z-index: 1000;\r\n    color: black;\r\n  }\r\n \r\n  \r\n  .notification-popup h3 {\r\n    margin: 0;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .notification-popup p {\r\n    margin: 0;\r\n  }\r\n\r\n  .no-notifications {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .no-notifications img {\r\n    margin-bottom: 10px;\r\n  }\r\n   */\r\n\r\n\r\n   /* ///////////////////////////////// */\r\n\r\n   .notification-popup {\r\n    position: absolute !important;\r\n    top: 70px;\r\n    right: 30px;\r\n    /* width: 550px; */\r\n    width: 550px;\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #dcdcdc;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    z-index: 1000;\r\n    color: #333; \r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.notification-popup h3 {\r\n    margin: 0 0 15px;\r\n    font-size: 18px;\r\n    color: #444;\r\n    font-weight: 600;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.notification-list {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.notification-card {\r\n    background-color: #fff;\r\n    border: 1px solid #e6e6e6;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.notification-card:hover {\r\n    background-color: #f0f0f0;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.notification-icon {\r\n    font-size: 17px;\r\n    color: #4f6ee8;\r\n    margin-right: 15px;\r\n    flex-shrink: 0;\r\n    align-self: flex-start;\r\n    width: 20px;\r\n    \r\n}\r\n\r\n/* .notificationtraining-icon{\r\n    font-size: 15px;\r\n    color: #007bff;\r\n    margin-right: 15px;\r\n    flex-shrink: 0;\r\n    align-self: flex-start;\r\n} */\r\n/* .notification-icon {\r\n    margin-right: 10px;\r\n    font-size: 1.5rem;\r\n    color: #75c5f4;\r\n  } */\r\n  \r\n  .notification-icon.faChalkboardTeacher {\r\n    color: #4a90e2 !important;\r\n  }\r\n  \r\n  .notification-icon.faBook {\r\n    color: #e94e77 !important;\r\n  }\r\n.notification-content {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    align-items: left; /* Aligns text vertically centered with the icon */\r\n    /* justify-content: space-between; */\r\n    text-align: left;\r\n    margin-left: 5px !important;\r\n    justify-content: space-between;\r\n    cursor: pointer;\r\n    \r\n    \r\n}\r\n\r\n.notification-content p {\r\n    margin: 0;\r\n    font-size: 15px;\r\n    color: #555;\r\n    text-align: left !important;\r\n    white-space: normal;\r\n    word-wrap: break-word;\r\n    \r\n}\r\n\r\n.notification-title {\r\n    margin: 0;\r\n    font-size: 18px;\r\n    color: #444;\r\n    font-weight: 600;\r\n  }\r\n\r\n.click-to-view {\r\n    color: #888;\r\n    font-size: 13px !important;\r\n    margin-top: 8px !important;\r\n    text-align: right !important;\r\n    flex-shrink: 0 !important; /* Prevents the text from shrinking */\r\n    margin-left: 0 !important; /* Adds space between the title and \"click to view\" */\r\n    white-space: nowrap;\r\n    margin-left: auto !important;\r\n    \r\n}\r\n\r\n.no-notifications {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 20px;\r\n}\r\n\r\n.no-notifications img {\r\n    margin-bottom: 10px;\r\n    width: 100px;\r\n    height: 100px;\r\n    opacity: 0.7;\r\n}\r\n\r\n.no-notifications p {\r\n    color: #777;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n.notification-list {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    max-height: 300px; /* Adjust based on your needs */\r\n    overflow-y: auto; /* Enables vertical scrolling */\r\n  }\r\n  .notification-list::-webkit-scrollbar {\r\n    width: 8px; /* Width of the scrollbar */\r\n  }\r\n  \r\n  .notification-list::-webkit-scrollbar-track {\r\n    background: #f9f9f9; /* Light background for the track */\r\n  }\r\n  \r\n  .notification-list::-webkit-scrollbar-thumb {\r\n    background: #ccc; /* Light gray thumb */\r\n    border-radius: 10px; /* Rounded thumb */\r\n    border: 2px solid #f9f9f9; /* Slight border around the thumb */\r\n  }\r\n  \r\n  .notification-list::-webkit-scrollbar-thumb:hover {\r\n    background: #aaa; /* Darker gray on hover */\r\n  }\r\n  \r\n  /* Custom scrollbar for Firefox */\r\n  .notification-list {\r\n    scrollbar-width: thin; /* Thin scrollbar width */\r\n    scrollbar-color: #ccc #f9f9f9; /* Thumb color and track color */\r\n  }\r\n\r\n  .notification-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    \r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .close-icon {\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    color: #888;\r\n  }\r\n  .clear-all-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 10px 15px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    margin-top: 10px !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
